import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalLeerMenuItem = ({ isOpen, toggle, selectedMenuItem }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Ver Item de Menú</ModalHeader>
            <ModalBody>
                {selectedMenuItem ? (
                    <div>
                        <p><strong>ID:</strong> {selectedMenuItem.id}</p>
                        <p><strong>Etiqueta:</strong> {selectedMenuItem.label}</p>
                        <p><strong>Descripción:</strong> {selectedMenuItem.description}</p>
                        <p><strong>Enlace:</strong> {selectedMenuItem.link}</p>
                        <p><strong>ID Padre:</strong> {selectedMenuItem.parent_id}</p>
                        <p><strong>Es item hijo:</strong> {selectedMenuItem.is_child_item ? 'Sí' : 'No'}</p>
                    </div>
                ) : (
                    <p>No se ha seleccionado un item de menú.</p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerMenuItem;